// Generated types for ModularRequirementAnalysisTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { NeoNodeReadAPI } from '../../shared/types/neonode';
import { TaskReadAPI, TaskWriteAPI } from '../../tasks/types/task';
import { NeoNodeReadAPISchema } from '../../shared/types/neonode';
import { TaskReadAPISchemaObject, TaskWriteAPISchemaObject } from '../../tasks/types/task';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ModularRequirementAnalysisTaskReadAPI extends TaskReadAPI {
}

export interface ModularRequirementAnalysisTaskWriteAPI extends TaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ModularRequirementAnalysisTaskReadAPISchema: z.ZodType<ModularRequirementAnalysisTaskReadAPI> = TaskReadAPISchemaObject.extend({}).passthrough();

export const ModularRequirementAnalysisTaskWriteAPISchema: z.ZodType<ModularRequirementAnalysisTaskWriteAPI> = TaskWriteAPISchemaObject.extend({}).passthrough();
